<template>
    <div class="d-flex justify-content-center w-100" id="navButton">
        <K2Row space-between="true" class="button-list-container w-100">
            <button class="btn btn-style btn-font-style rounded-pill py-1 px-0  p-md-2 flex-grow-1"
                    @click="changePage(item.value)" v-for="item in buttonlist"
                    :class="[{'active' : currentPage === item.value},
                    {'bc-alert-bg' : (hasBroadcastAlert && item.value === 'broadcast' && currentPage !== 'broadcast')}]">
                <!-- currentPage === item.value ? 'active' : '' -->

                <div class="row" style="margin: 0px;">
                    <!--                    <div>-->
                    <!--                        <i class="fa " :class="item.iconName ? item.iconName : ''"></i>-->
                    <!--                    </div>-->

                    <div>
                        <el-badge value="NEW" class="broadcast-alert"
                                  v-if="hasBroadcastAlert && item.value === 'broadcast'">
                        </el-badge>

                        <span class="btn-name">{{item.name}}</span>
                    </div>
                </div>

            </button>
        </K2Row>

        <!--        <div class="nav-search-container col-md-3"></div>-->
    </div>
</template>

<script>
    import Cookies from "js-cookie";
    import $ from 'jquery';
    import DataSource from "../data/datasource";
    import {lang} from '../locale/index';
    import K2Row from "../uiComponents/k2Row/k2Row";
    import staffClassPlanner from "@/pages/PlannerAssignClass";
    // import ProfileImg from "../assets/boy.png";

    export default {
        name: "NavButton",
        props: ["passCurrentPage", "passBroadcastAlert"],
        components: {
            K2Row
        },
        data() {
            return {
                buttonlist: [],
                currentPage: 'feed',
                userType: '',
                schUniversity: '',

                termlyReportList: [],
                numberOfTermlyReport: "3",
                lastTermlyReportID: "",
                mode: "Self",

                hasBroadcastAlert: false,
            };
        },
        created() {
            this.userType = Cookies.get('userTypeSession');
            this.schUniversity = Cookies.get('userUniversitySession');
        },
        destroyed() {

        },
        methods: {
            lang,

            changePage(val) {
                $(".search-feed-container").remove();
                this.currentPage = val;
                this.$emit("changePageFromChild", this.currentPage);
                if (this.$route.query.tour !== undefined) {
                    this.$router.replace({'query': null});
                }
            },

            async getTermlyReportPublishList() {
                this.termlyReportList = [];
                this.$vs.loading();

                try {
                    const response = await DataSource.shared.getPublishedTermlyReport(this.numberOfTermlyReport, this.lastTermlyReportID, this.mode);

                    if (response.code === '88') {
                        console.log('Cannot get summative report! code 88');
                    } else if (response.code === '99') {
                        console.log('Cannot get summative report! code 99');
                    } else if (response.code === '2') {
                        console.log('Empty list!');
                    } else {
                        this.termlyReportList = response.Table;
                    }

                    // console.log(this.termlyReportList.length, "list");
                } catch (e) {
                    console.log(e);
                }
                this.$vs.loading.close();
            },
        },
        async mounted() {
            await this.getTermlyReportPublishList();

            if (this.schUniversity === "UTY201300000061") {
                if (this.userType === "Parent") {
                    this.buttonlist = [
                        {
                            "name": lang("News Feed"),
                            "iconName": "fa-align-justify",
                            "linkto": "newfeed",
                            "value": "feed"
                        },
                        {
                            "name": lang("Broadcast"),
                            "iconName": "fa-bullhorn",
                            "linkto": "newbroadcast",
                            "value": "broadcast"
                        },
                        {
                            "name": "Moments",
                            "iconName": "fa-th-large",
                            "linkto": "portfolio",
                            "value": "moment"
                        },
                        {
                            "name": lang("Event"),
                            "iconName": "fa-calendar",
                            "linkto": "newEvent",
                            "value": "event"
                        },
                        // {
                        //     "name": lang("Travel Declaration"),
                        //     "iconName": "fa-plane",
                        //     "linkto": "traveldeclaration",
                        //     "value": "travelDeclaration"
                        // },
                        {
                            "name": lang("Declaration Form"),
                            "iconName": "fa-plane",
                            "linkto": "declarationform",
                            "value": "declarationForm"
                        },
                        {
                            "name": lang("Message"),
                            "iconName": "fa-envelope",
                            "linkto": "",
                            "value": "dm"
                        },

                        // {
                        //     "name": lang("Summative Report"),
                        //     "iconName": "fa-clipboard",
                        //     "linkto": "termlyReportList",
                        //     "value": "termlyReportList"
                        // },

                        // {
                        //     "name": lang("Daily Log"),
                        //     "iconName": "fa-newspaper-o",
                        //     "linkto": "dailyRoutineParent",
                        //     "value": "dailyRoutineParent"
                        // },
                        // {
                        //     "name": lang("Survey"),
                        //     "iconName": "fa-file-text-o",
                        //     "linkto": "survey",
                        //     "value": "survey"
                        // },
                    ];

                    // check if got termly report post
                    if (this.termlyReportList.length > 0) {
                        this.buttonlist.push(
                            {
                                "name": lang("Termly Report"),
                                "iconName": "fa-clipboard",
                                "linkto": "termlyReportList",
                                "value": "termlyReportList"
                            }
                        );
                    }
                } else {
                    this.buttonlist = [
                        {
                            "name": lang("Activities"),
                            "iconName": "fa-align-justify",
                            "linkto": "newfeed",
                            "value": "feed"
                        },
                        // {
                        //     "name": lang("Broadcast"),
                        //     "iconName": "fa-bullhorn",
                        //     "linkto": "newbroadcast",
                        //     "value": "broadcast"
                        // },
                        // {
                        //     "name": lang("Attendance"),
                        //     "iconName": "fa-calendar-check-o",
                        //     "linkto": "attendance",
                        //     "value": "attendance"
                        // },
                        // {
                        //     "name": lang("Moments"),
                        //     "iconName": "fa-th-large",
                        //     "linkto": "portfolio",
                        //     "value": "moment"
                        // },
                        {
                            "name": lang("Event"),
                            "iconName": "fa-calendar",
                            "linkto": "newEvent",
                            "value": "event"
                        },
                        {
                            "name": lang("Termly Report"),
                            "iconName": "fa-clipboard",
                            "linkto": "termlyReport",
                            "value": "report"
                        },
                        // {
                        //     "name": lang("Planner"),
                        //     "iconName": "fa-calendar",
                        //     "linkto": "planner",
                        //     "value": "planner"
                        // },
                        // {
                        //     "name": lang("Planner"),
                        //     "iconName": "fa-calendar",
                        //     "linkto": "planner",
                        //     "value": "planner"
                        // },
                        // {
                        //     "name": lang("GoalPlanner"),
                        //     "iconName": "fa-calendar",
                        //     "linkto": "classPlanner",
                        //     "value": "classPlanner"
                        // },
                        // {
                        //     "name": lang("Planner Assign Student"),
                        //     "iconName": "fa-calendar",
                        //     "linkto": "planner",
                        //     "value": "planner"
                        // },
                        {
                            "name": lang("Message"),
                            "iconName": "fa-envelope",
                            "linkto": "",
                            "value": "dm"
                        },

                    ];

                    if (this.userType === "Teacher") {
                        this.buttonlist.push(
                            {
                                "name": lang("Daily Log"),
                                "iconName": "fa-newspaper-o",
                                "linkto": "dailyRoutine",
                                "value": "dailyRoutine"
                            },
                            {   //Added dm for teacher 20210917
                                "name": lang("Message"),
                                "iconName": "fa-envelope",
                                "linkto": "",
                                "value": "dm"
                            }
                        );
                    }
                }
            } else {
                if (this.userType === "Parent") {
                    this.buttonlist = [
                        {
                            "name": lang("News Feed"),
                            "iconName": "fa-align-justify",
                            "linkto": "newfeed",
                            "value": "feed"
                        },
                        {
                            "name": lang("Broadcast"),
                            "iconName": "fa-bullhorn",
                            "linkto": "newbroadcast",
                            "value": "broadcast"
                        },
                        {
                            "name": "Moments",
                            "iconName": "fa-th-large",
                            "linkto": "portfolio",
                            "value": "moment"
                        },
                        {
                            "name": lang("Event"),
                            "iconName": "fa-calendar",
                            "linkto": "newEvent",
                            "value": "event"
                        },
                        // {
                        //     "name": lang("Travel Declaration"),
                        //     "iconName": "fa-plane",
                        //     "linkto": "traveldeclaration",
                        //     "value": "travelDeclaration"
                        // },
                        {
                            "name": lang("Declaration Form"),
                            "iconName": "fa-plane",
                            "linkto": "declarationform",
                            "value": "declarationForm"
                        },
                        {
                            "name": lang("Message"),
                            "iconName": "fa-envelope",
                            "linkto": "",
                            "value": "dm"
                        },
                        // {
                        //     "name": lang("Survey"),
                        //     "iconName": "fa-file-text-o",
                        //     "linkto": "survey",
                        //     "value": "survey"
                        // },
                    ];

                    // it.software@etonhouse.com.sg , kgmmot@yopmail.com
                    if (Cookies.get('userEmailSession') === "kgmmot@yopmail.com") {
                        this.buttonlist.push(
                            {
                                "name": lang("Billing"),
                                "iconName": "fa-credit-card",
                                "linkto": "ebilling",
                                "value": "ebilling"
                            }
                        );
                    }

                    // check if got termly report post
                    if (this.termlyReportList.length > 0) {
                        this.buttonlist.push(
                            {
                                "name": lang("Termly Report"),
                                "iconName": "fa-clipboard",
                                "linkto": "termlyReportList",
                                "value": "termlyReportList"
                            }
                        );
                    }
                } else {
                    this.buttonlist = [
                        {
                            "name": lang("News Feed"),
                            "iconName": "fa-align-justify",
                            "linkto": "newfeed",
                            "value": "feed"
                        },
                        {
                            "name": lang("Broadcast"),
                            "iconName": "fa-bullhorn",
                            "linkto": "newbroadcast",
                            "value": "broadcast"
                        },
                        {
                            "name": lang("Attendance"),
                            "iconName": "fa-calendar-check-o",
                            "linkto": "attendance",
                            "value": "attendance"
                        },
                    ];
                }
            }
        },
        watch: {
            passCurrentPage: function (newVal, oldVal) { // watch it

                if (newVal && newVal !== oldVal) {
                    this.currentPage = newVal;
                }
            },

            passBroadcastAlert: function (newVal, oldVal) { // watch it
                if (newVal && newVal !== oldVal) {
                    this.hasBroadcastAlert = newVal;
                }
            },
        },
    };
</script>

<style scoped>
    #navButton {
        margin: 0 auto;
    }

    .button-list-container,
    .nav-search-container {
        /*display: inline-block;*/
        padding: 0;
    }

    .btn-style {
        background: #FFFFFF;
        border-radius: 3px;
        color: #536170;
        margin-right: 10px;
        /*margin-bottom: 5px;*/
        font-size: 14px;
        position: relative;
    }

    .btn-name {
        /*margin-left: 10px;*/
    }


    .btn-style.active {
        background: #e0696c;
        color: #FFFFFF;
    }

    .btn-font-style {
        font-family: sans-serif, KaiTi;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }

    .mobile-view .btn-style {
        background: transparent;
        color: #C9D5FF;
        border-radius: 20px;
    }

    .mobile-view .btn-style.active {
        background: #426DFF;
        color: #FFFFFF;
    }

    .bc-alert-bg {
        background: #E9EDF7;
    }

    .broadcast-alert {
        position: absolute;
        top: -8px;
        left: 5px;
    }
</style>

<style>
    .broadcast-alert .el-badge__content {
        background: #F5222D;
        font-size: 8px;
        border-radius: 4px;
        padding: 0px 4px;
        border: unset;
        height: 15px;
    }
</style>